import { PayloadAction, createSlice } from "@reduxjs/toolkit";

import { DEFAULT_DRAFT_COLORS } from "../constants";

export interface ThemeSlice {
  teamColor: string;
  teamLogo: string;
  teamName: string;
  teamNickName: string;
  draftColors: string[];
}

const initialState: ThemeSlice = {
  teamColor: "",
  teamLogo: "",
  teamName: "",
  teamNickName: "",
  draftColors: DEFAULT_DRAFT_COLORS,
};

export const themeSlice = createSlice({
  name: "theme",
  initialState,
  reducers: {
    setTeamTheme: (
      state,
      action: PayloadAction<Pick<ThemeSlice, "teamColor" | "teamLogo" | "teamName" | "teamNickName">>
    ) => {
      state.teamColor = action.payload.teamColor;
      state.teamLogo = action.payload.teamLogo;
      state.teamName = action.payload.teamName;
      state.teamNickName = action.payload.teamNickName;
    },
    setDraftColors: (state, action: PayloadAction<Pick<ThemeSlice, "draftColors">>) => {
      state.draftColors = action.payload.draftColors;
    },
  },
});

export const { setTeamTheme, setDraftColors } = themeSlice.actions;
export const themeSliceReducer = themeSlice.reducer;
